import * as React from "react";
import { BillingAccount, BillingUserRole } from "../../schema/types/account";
import { Button, Dropdown, Tag } from "antd";
import { ItemType, MenuItemType } from "antd/es/menu/interface";
import { ViewModal } from "../../components/modals/viewModal";
import { ChevronDown } from "react-feather";
import { useLocation } from "react-router-dom";

interface Props {
  account: BillingAccount;
  roles: BillingUserRole[];
}
export const AccountDetailHeader: React.FC<Props> = ({ account, roles }) => {
  const kind: any = account.kind;
  const { pathname } = useLocation();

  const [action, setAction] = React.useState<"view" | "">("");

  async function handleActionsClick({ key }: any) {
    switch (key) {
      case "view":
        setAction("view");
        break;
      default:
        break;
    }
  }

  const items: ItemType<MenuItemType>[] = [];
  items.push({ key: "view", label: "View" });

  function viewModalOnClose() {
    setAction("");
  }

  return (
    <>
      <div className="n-detail-header flex items-center justify-between pb-4 h-20 z-10">
        <div>
          <div data-testid="detail-kind" className="text-dark text-xs">
            {kind.toUpperCase()}
            {account.extraInfo?.company ? ` | COMPANY` : ""}
          </div>
          <div className="flex items-center">
            <div data-testid="detail-name" className="text-2xl font-semibold leading-none">
              {account.accountName || account.fullName || account.id}
              {account.extraInfo?.company ? ` | ${account.extraInfo?.company}` : ""}
            </div>
            <div className="ml-4 flex items-center">
              {roles.map((role) => (
                <Tag key={role}>{role}</Tag>
              ))}
            </div>
          </div>
        </div>
        <div className="flex-grow" />
        {pathname.includes(`/usage`) ? null : (
          <div className="flex items-center gap-2">
            {items.length > 0 ? (
              <Dropdown trigger={["click"]} menu={{ items: items, className: "menu", onClick: handleActionsClick }}>
                <Button type={"primary"} size="small" icon={<ChevronDown />} iconPosition="end">
                  Actions
                </Button>
              </Dropdown>
            ) : null}
          </div>
        )}
      </div>
      {action === "view" ? (
        <ViewModal
          kind={kind}
          visible={true}
          onClose={viewModalOnClose}
          title={"Account"}
          filename={`account-${account.id}`}
          object={account}
        />
      ) : null}
    </>
  );
};
